// extracted by mini-css-extract-plugin
export default {"tasks":"eO-z","task":"fO-z","svg":"gO-z","text":"hO-z"};